import { useEffect } from 'react';

export function useEffectOnce(callback: () => void) {
  useEffect(() => {
    callback();
    // oxlint-disable-next-line eslint-plugin-react-hooks/exhaustive-deps : this hooks had been removed from library (see https://usehooks-ts.com/migrate-to-v3), emulating it
  }, []);
}
